import {
  faSignOutAlt,
  faStar,
  faTasks,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { NavigationItem } from "./NavigationItem.Interface";
import "./Usermenu.Styles.scss";

interface Props {
  active: string;
  setActive: (str: string) => void;
  activeUserMenu: boolean;
}

export default function UsermenuComponent(props: Props) {
  const history = useHistory();
  const firebase = useContext(firebaseContext);

  const logout = async () => {
    firebase
      .auth()
      .signOut()
      .then((user) => {
        console.log(user);
      });
  };

  const navItems: NavigationItem[] = [
    {
      title: "My Profile",
      icon: faUser,
      key: "user",
    },
    {
      title: "My Team",
      icon: faStar,
      key: "myteam",
    },
    {
      title: "Manage",
      icon: faTasks,
      key: "manageteam",
    },
    {
      title: "Logout",
      icon: faSignOutAlt,
      onClick: logout,
      key: "logout",
    },
  ];

  const onClickItem = (ele: NavigationItem) => {
    props.setActive(ele.key);
    history.push("/" + ele.key);
  };

  const renderNavElements = () => {
    return navItems.map((ele, id) => {
      return (
        <li
          className={props.active === ele.key ? "active" : ""}
          key={id}
          onClick={() => (ele.onClick ? ele.onClick() : onClickItem(ele))}
        >
          <span>{ele.title}</span>
          <FontAwesomeIcon icon={ele.icon} />
        </li>
      );
    });
  };

  return (
    <div
      className={`user-menu ${
        props.activeUserMenu ? "user-menu-active " : " "
      }`}
    >
      <ul>{renderNavElements()}</ul>
    </div>
  );
}
